<template>
  <div></div>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CSSPlugin } from 'gsap/CSSPlugin'

gsap.registerPlugin(ScrollTrigger, CSSPlugin)

export default {
  methods: {
    fadeInUp() {
      gsap.utils.toArray('.global__fade-in-up').forEach(function(item) {
        const fadeInUp = gsap.timeline({
          scrollTrigger: {
            trigger: item,
            // toggleActions: 'restart none none reverse',
            start: 'top 95%',
          },
        })

        fadeInUp.from(item, {
          ease: 'expo.out',
          duration: 1.5,
          opacity: 0,
          y: '50',
        })
      })
    },

    blockSlide() {
      gsap.utils.toArray('.background__block').forEach(function(item) {
        const blockSlide = gsap.timeline({
          scrollTrigger: {
            trigger: item,
            // toggleActions: 'restart none none reverse',
            start: 'top 95%',
          },
        })

        blockSlide
          .from(item, {
            ease: 'expo.out',
            duration: 1,
            width: '0%',
          })
          .to(item, {
            width: '100%',
          })
      })
    },

    drawLine() {
      gsap.utils.toArray('.stats3__bar').forEach(function(item) {
        const drawLine = gsap.timeline({
          scrollTrigger: {
            trigger: item,
            // toggleActions: 'restart none none reverse',
            start: 'top 95%',
            toggleClass: 'active',
            once: true,
          },
        })

        drawLine
      })
    },

    drawNewsLine() {
      gsap.utils.toArray('.news-listing__bar').forEach(function(item) {
        const drawLine = gsap.timeline({
          scrollTrigger: {
            trigger: item,
            // toggleActions: 'restart none none reverse',
            start: 'top 95%',
            toggleClass: 'active',
          },
        })

        drawLine.from(item, {
          ease: 'expo.out',
          duration: 0.5,
        })
      })
    },

    sunburst() {
      gsap.utils.toArray('.global__sunburst').forEach(function(item) {
        const sunburst = gsap.timeline({
          scrollTrigger: {
            trigger: item,
            // toggleActions: 'restart none none reverse',
            start: 'top 75%',
          },
        })

        sunburst
          .from(item, {
            ease: 'expo.out',
            duration: 1.5,
            scale: 0.3,
          })
          .to(item, {
            scale: 1,
          })
      })
    },

    bgParallax() {
      gsap.utils.toArray('.global__parallax-bg').forEach(function(item) {
        item.bg = item.querySelector('.background__image-img')

        const bgParallax = gsap.timeline({
          scrollTrigger: {
            trigger: item,
            scrub: true,
            start: 'top 90%',
            end: 'bottom 10%',
          },
        })

        bgParallax
          .from(item.bg, {
            objectPosition: '50% 100%',
          })
          .to(item.bg, {
            objectPosition: '50% 0%',
          })
      })
    },
  },
  mounted: function() {
    this.fadeInUp()
    this.blockSlide()
    this.drawLine()
    this.drawNewsLine()
    this.sunburst()
    this.bgParallax()
  },
}
</script>

<style lang="scss" scoped>
.global__sunburst {
  transform-origin: center;
}
</style>
